<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="订单号" prop="ordernum">
      <el-input v-model="dataForm.ordernum" placeholder="订单号"></el-input>
    </el-form-item>
    <el-form-item label="openid" prop="openid">
      <el-input v-model="dataForm.openid" placeholder="openid"></el-input>
    </el-form-item>
    <el-form-item label="名称" prop="name">
      <el-input v-model="dataForm.name" placeholder="名称"></el-input>
    </el-form-item>
    <el-form-item label="电话" prop="phone">
      <el-input v-model="dataForm.phone" placeholder="电话"></el-input>
    </el-form-item>
    <el-form-item label="状态" prop="status">
      <el-input v-model="dataForm.status" placeholder="状态"></el-input>
    </el-form-item>
    <el-form-item label="金额" prop="money">
      <el-input v-model="dataForm.money" placeholder="金额"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createtime">
      <el-input v-model="dataForm.createtime" placeholder="创建时间"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          ordernum: '',
          openid: '',
          name: '',
          phone: '',
          status: '',
          money: '',
          createtime: ''
        },
        dataRule: {
          ordernum: [
            { required: true, message: '订单号不能为空', trigger: 'blur' }
          ],
          openid: [
            { required: true, message: 'openid不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '名称不能为空', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '电话不能为空', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '状态不能为空', trigger: 'blur' }
          ],
          money: [
            { required: true, message: '金额不能为空', trigger: 'blur' }
          ],
          createtime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: `/jxjg/jgliushui/info/${this.dataForm.id}`,
              method: 'get',
              params: this.$http.adornParams()
            }).then((data) => {
              if (data && data.code === 0) {
                this.dataForm.ordernum = data.jgliushui.ordernum
                this.dataForm.openid = data.jgliushui.openid
                this.dataForm.name = data.jgliushui.name
                this.dataForm.phone = data.jgliushui.phone
                this.dataForm.status = data.jgliushui.status
                this.dataForm.money = data.jgliushui.money
                this.dataForm.createtime = data.jgliushui.createtime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `/jxjg/jgliushui/${!this.dataForm.id ? 'save' : 'update'}`,
              method: 'post',
              params: {
                'id': this.dataForm.id || undefined,
                'ordernum': this.dataForm.ordernum,
                'openid': this.dataForm.openid,
                'name': this.dataForm.name,
                'phone': this.dataForm.phone,
                'status': this.dataForm.status,
                'money': this.dataForm.money,
                'createtime': this.dataForm.createtime
              }
            }).then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/jgliushui-add-or-update.vue